import '../../style/index.less';
import './index.less';

// style dependencies
import '../../button/style';
import "../../style/nsky/reset/modal/index.less";



/** WEBPACK FOOTER **
 ** ./components/modal/style/index.js
 **/